module.exports = __webpack_public_path__ + "media/images/flags/1x1/sur-dafa1fa4c800a9e607b83043113bb0af.svg";